import { createMutationHelper } from '@utils/swr'
import { type ECommerceUpdateOrderPaymentTokenRequest } from '../types/apiRequest'
import { type EcommerceUpdateOrderPaymentTokenResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<ECommerceApis['put']['updateOrderPaymentToken'], EcommerceUpdateOrderPaymentTokenResponse, ECommerceUpdateOrderPaymentTokenRequest>({
  client: 'eCommerce',
  key: '/orders/:id/payment_token',
  fetcher: (_url, { arg, client }) => {
    const { id, ...rest } = arg
    return client.put(`/orders/${id}/payment_token`, rest)
  },
})

export const useApiECommerceUpdateOrderPaymentToken = useMutation
